package nl.astraeus.wiki.domain

class User(
  var id: Long = 0,
  var email: String = "",
  var name: String = "",
  var password: String = "",
  var lastLogin: Long = 0,
)
